export default "__VITE_ASSET__BOTKwFyd__"